import script from "./remark-card.vue?vue&type=script&setup=true&lang=js"
export * from "./remark-card.vue?vue&type=script&setup=true&lang=js"

import "./remark-card.vue?vue&type=style&index=0&id=773eaa97&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-773eaa97"]])

export default __exports__